var style = {"z-shadowbox":"z-shadowbox"};

export { style as default };
//# sourceMappingURL=ShadowBox.module.scss.js.map
